import { graphql } from "babel-plugin-relay/macro";

export const mutation = graphql`
    mutation maintainSigneeOrderMutation($input: MaintainSigneeOrderInput!){
        maintainSigneeOrder(input: $input) {
            success
        }
    }
`;
